export default `
mutation createEmptyQuoteCart($input: createEmptyQuoteCartInput) {
    createEmptyQuoteCart(input: $input)
}
`;
